import { useParams } from "react-router-dom";
import { ProgramPhases } from "./ProgramPhases";
import { ParticipantNotOnboardedMessage } from "../ParticipantNotOnboardedMessage";
import { ParticipantWithdrawnMessage } from "../ParticipantWithdrawnMessage";
import { useProgram } from "@platform/hooks/useProgram";
import { useIsEnrollmentClosed } from "@platform/hooks/useIsEnrollmentClosed";
import { PROGRAM_ROLE_SLUG } from "@core/features/program";

export function ProgramPhasesContainer() {
  const { id: programId } = useParams<{ id: string }>();
  const { program, phases, currentPhase, isLoading } = useProgram();
  const isEnrollmentClosed = useIsEnrollmentClosed();

  const userRoles = program?.user_roles;
  const isEnrolledParticipant = userRoles?.includes(
    PROGRAM_ROLE_SLUG.ENROLLED_PARTICIPANT
  );
  const isOnboardedParticipant = userRoles?.includes(
    PROGRAM_ROLE_SLUG.ONBOARDED_PARTICIPANT
  );
  const isWithdrawn = userRoles?.includes(PROGRAM_ROLE_SLUG.WITHDRAWN_USER);

  if (isWithdrawn) {
    return <ParticipantWithdrawnMessage />;
  }

  if (!isEnrolledParticipant) {
    return null;
  }

  if (isEnrollmentClosed && !isOnboardedParticipant) {
    return <ParticipantNotOnboardedMessage />;
  }

  return (
    <ProgramPhases
      currentPhase={currentPhase}
      phases={phases}
      isLoading={isLoading}
      programId={Number(programId)}
    />
  );
}

export default ProgramPhasesContainer;
